<template>
    <div class="window">
      <div class="title-bar">
        <div class="d-flex jc-center" style="width: 100%;display: flex; justify-content: space-around;margin-top: 1%;">
          <dv-decoration-10 class="decoration-0" :style="color" />
          <div class="d-flex jc-center" style="display: flex; justify-content: space-around;width: 20%;">
            <!-- <dv-decoration-8 :color="['#568aea', '#000000']"
                             style="width:2.5rem;height: .625rem;" /> -->
            <div class="title">
              <div style="text-align: center;   font-size:calc(100vw * 40 / 1920); font-weight: 900;color: #0166FF;">{{title}}</div>
              <!-- <dv-decoration-6 class="title-bototm"
                               :reverse="true"
                               :color="['#50e3c2', '#67a1e5']"
                               style="width:12.925rem;height:.1rem;" /> -->
            </div>
            <!-- <dv-decoration-8 :reverse="true"
                             :color="['#568aea', '#000000']"
                             style="width:2.5rem;height:.625rem;" /> -->
          </div>
          <dv-decoration-10 class="decoration-1" :style="color" />
        </div>

      <!-- <h3>
        {{ title }}
      </h3> -->
      <div style="position: absolute; right: 1%; top: 50%;  display: flex; flex-direction:row">
        <el-tooltip
        class="box-item"
        effect="dark"
        content="知识点讲解"
        placement="bottom"
      >
        <div v-if="knowledgeShow" style="margin-right: calc(100vw * 8 / 1920);margin-bottom: calc(100vw * 4 / 1920);display: flex;align-items: center;cursor: pointer;" @click="KnowledgeClick" v-loading="loding">
          <svg t="1716444937468" class="icon" viewBox="0 0 1088 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2646" width="calc(100vw * 30 / 1920)" height="calc(100vw * 30 / 1920)"><path d="M128 64a64 64 0 0 0-64 64v768a64 64 0 0 0 64 64h288a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64H128z m0-64h288a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H128a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128z" fill="#0166FF" p-id="2647"></path><path d="M157.44 352a32 32 0 1 1 0-64h243.392a32 32 0 1 1 0 64H157.504zM157.44 544a32 32 0 1 1 0-64h186.112a32 32 0 1 1 0 64H157.504zM157.44 736a32 32 0 1 1 0-64h128.896a32 32 0 1 1 0 64H157.44z" fill="#0166FF" p-id="2648"></path><path d="M614.72 64a64 64 0 0 0-64 64v768a64 64 0 0 0 64 64h288a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64h-288z m0-64h288a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128h-288a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128z" fill="#0166FF" p-id="2649"></path><path d="M644.224 352a32 32 0 1 1 0-64h243.328a32 32 0 1 1 0 64h-243.328zM644.224 544a32 32 0 1 1 0-64h186.112a32 32 0 1 1 0 64h-186.112zM644.224 736a32 32 0 1 1 0-64h128.832a32 32 0 1 1 0 64h-128.832z" fill="#0166FF" p-id="2650"></path></svg>
        </div>
      </el-tooltip>
        <div v-if="returnShow" @click="Revert" style="margin-right: calc(100vw * 1 / 1920);margin-top: 1px;cursor: pointer;">
          <svg t="1710739972194" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4565" width="calc(100vw * 38 / 1920)" height="calc(100vw * 40 / 1920)"><path d="M622.650611 284.901749 447.745069 284.901749 447.745069 142.823869 63.980685 334.705038l383.76336 191.882192L447.744046 384.834762l189.391465 0c149.914358 0 224.855164 62.789045 224.855164 188.368158 0 129.928165-77.435627 194.876386-232.338602 194.876386L187.952184 768.079306l0 99.93199L634.146433 868.011296c211.184817 0 316.777737-95.104031 316.777737-285.311071C950.924169 384.178823 841.510224 284.901749 622.650611 284.901749z" :fill=" Global.globalColor" p-id="4566"></path></svg>
        </div>
        <div @click="Close" style="cursor: pointer;">
          <svg t="1710740199927" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10982" width="calc(100vw * 48 / 1920)" height="calc(100vw * 42 / 1920)"><path d="M601.376 512l191.52-191.52c28.096-28.096 30.976-71.168 6.4-95.744s-67.68-21.696-95.744 6.4l-191.52 191.52-191.52-191.52c-28.096-28.096-71.168-30.976-95.744-6.368s-21.696 67.68 6.4 95.744l191.52 191.52-191.52 191.52c-28.096 28.096-30.976 71.168-6.368 95.744s67.68 21.696 95.744-6.4l191.52-191.52 191.52 191.52c28.096 28.096 71.168 30.976 95.744 6.4s21.696-67.68-6.4-95.744l-191.52-191.52z" :fill=" Global.globalColor" p-id="10983"></path></svg>
        </div>
      </div>
    </div>
      <div class="window-content">
        <slot></slot>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'Window',
    props:["title","knowledgeType"],
    data() {
      return {
        loding:false,
        returnShow: false,
        knowledgeShow:false,
        color:{
          'background-color' : this.Global.globalColor
        }
      }
    },
    mounted(){
      this.knowledgeShow = false
      if(this.knowledgeType!=undefined){
        this.knowledgeShow = true
      }
    },
    methods: {
      KnowledgeClick(){
        try {
          this.loding = true
          // 创建 XMLHttpRequest 对象
          const xhr = new XMLHttpRequest();
          // 设置请求的 URL
          xhr.open("GET", this.Global.knowledgeurl + `api/Knowledge/GetknowledgeTypeCount?knowledgeType=${this.knowledgeType}&projectID=${this.Global.ProjectType.会展项目}`, true);
          // 设置响应类型为 text/event-stream
          xhr.setRequestHeader("Content-Type", "application/json");
          // 监听 readyStateChange 事件
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                if(JSON.parse(xhr.response).success == true){
                   this.$router.push({ path: '/KnowledgeControl', query: {id : this.knowledgeType}});
                   this.loding = false
                }else{
                  this.loding = false
                  this.$message.error(JSON.parse(xhr.response).message);
                }

              }
            }
          };
          xhr.send();
        } catch (error) {
          this.loding = false
          this.$message.success(error)
        }
      },
      Close() {
        if(this.$route.path != '/selectiveexperiment' && this.$route.path != '/Previewtopic'){
           this.$router.push(`/Main`);
        }else{
          this.$emit('close')
        }
      },
      Revert(){
        this.returnShow = false
        this.$emit('revert')
      },
      receiveValue(value)
      {
        this.returnShow = value
      }
    }
  }
  </script>
  <style scoped>
  .window {
    background-color: white;
    display: flex;
    flex-direction:column;
    align-items: center;
    width: 100%;
    border-radius: 15px;
    overflow-x: hidden;overflow-y: auto;
  }
  .title-bar {
    height: 8%;
    width: 100%;
    /* background-color: #e8e8e8; */
    display: flex;
    justify-content: center;
    border-radius: 15px 15px 0px 0px;
    position: relative;
  }
  .close-btn {
    width: 16px;
    height: 16px;
    border: none;
    outline: none;
    /* background-image: url("关闭按钮图片路径"); */
    background-size: cover;
    margin-right: 3px;
  }
  .content {
    padding: 10px;
  }
  .window-content {
    height: 92%;
    width: 100%;
    display: flex;
    justify-content: center;
    /* align-items: center; */
  }
  .decoration-0{
    width:35.3%;
    height:.1625rem;
  }
  .decoration-1{
    width:35.3%;
    height:.1625rem;
    transform: rotateY(180deg);
  }
  </style>
  